import { createRouteRef } from '@backstage/frontend-plugin-api';

export const vibeCodedAppsRouteRef = createRouteRef();
